"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeViewportCallback = exports.removeResizeCallback = exports.removeRatioCallback = exports.getViewportSize = exports.addViewportCallback = exports.addResizeCallback = exports.addRatioCallback = void 0;
var _RegisterEventHandler = require("./RegisterEventHandler");
var resizeCallbacks = [];
var ratioCallbacks = [];
var viewportCallbacks = [];
var viewport;
var eventHandler;
var getViewportSize = function getViewportSize() {
  if (typeof document === "undefined") {
    return "xs";
  }
  return document.body && window.getComputedStyle(document.body, ":after").content.replace(/["']/g, "");
};
exports.getViewportSize = getViewportSize;
var runCallbacks = function runCallbacks() {
  eventHandler.unsetRunning();
  var newViewport = document.body && window.getComputedStyle(document.body, ":after").content.replace(/["']/g, "");
  if (viewport !== newViewport) {
    viewport = newViewport;
    viewportCallbacks.forEach(function (callback) {
      callback(getViewportSize());
    });
  }
  var ratio = window.innerWidth / window.innerHeight;
  resizeCallbacks.forEach(function (callback) {
    callback();
  });
  ratioCallbacks.forEach(function (callbackObject) {
    var minRatio = callbackObject.minRatio,
      lastResult = callbackObject.lastResult,
      callback = callbackObject.callback;
    var currentResult = ratio >= minRatio;
    if (currentResult !== lastResult) {
      callback(currentResult);
      // eslint-disable-next-line no-param-reassign
      callbackObject.lastResult = currentResult;
    }
  });
};
var tryRegisterHandler = function tryRegisterHandler() {
  eventHandler = eventHandler || (0, _RegisterEventHandler.registerEventHandler)("resize", runCallbacks);
  viewport = viewport || getViewportSize();
};
var tryUnregisterHandler = function tryUnregisterHandler() {
  if (!resizeCallbacks.length && !ratioCallbacks.length && !viewportCallbacks.length && eventHandler) {
    eventHandler.unsubscribe();
    eventHandler = undefined;
  }
};
var addResizeCallback = function addResizeCallback(callback) {
  tryRegisterHandler();
  resizeCallbacks.push(callback);
  runCallbacks();
};
exports.addResizeCallback = addResizeCallback;
var addRatioCallback = function addRatioCallback(minRatio, callback) {
  tryRegisterHandler();
  ratioCallbacks.push({
    callback: callback,
    lastResult: undefined,
    minRatio: minRatio
  });
  runCallbacks();
};
exports.addRatioCallback = addRatioCallback;
var addViewportCallback = function addViewportCallback(callback) {
  tryRegisterHandler();
  viewportCallbacks.push(callback);
  runCallbacks();
};
exports.addViewportCallback = addViewportCallback;
var removeResizeCallback = function removeResizeCallback(callback) {
  resizeCallbacks = resizeCallbacks.filter(function (c) {
    return c !== callback;
  });
  tryUnregisterHandler();
};
exports.removeResizeCallback = removeResizeCallback;
var removeRatioCallback = function removeRatioCallback(callback) {
  ratioCallbacks = ratioCallbacks.filter(function (o) {
    return o.callback !== callback;
  });
  tryUnregisterHandler();
};
exports.removeRatioCallback = removeRatioCallback;
var removeViewportCallback = function removeViewportCallback(callback) {
  viewportCallbacks = viewportCallbacks.filter(function (c) {
    return c !== callback;
  });
  tryUnregisterHandler();
};
exports.removeViewportCallback = removeViewportCallback;